module.exports = __webpack_public_path__ + "media/usa_pcb_assembly/icons_clock-b5763dab.svg";